export const DISCOUNT_COUPON_FUNDED_BY = {
  RESTAURANT: "RESTAURANT",
  MORFY: "MORFY",
  MIXED: "MIXED",
};
